import { FormattedMessage } from 'react-intl';

export const prefixConfigCardMessages = {
  'prefixConfigCard.limitField.label': (
    <FormattedMessage
      id="prefixConfigCard.limitField.label"
      defaultMessage="Limit (char)"
    />
  ),
  'prefixConfigCard.limitField.placeholder': (
    <FormattedMessage
      id="prefixConfigCard.limitField.placeholder"
      defaultMessage="Enter limit"
    />
  ),
  'prefixConfigCard.limitField.exceedError': (maxLimit: number) => (
    <FormattedMessage
      id="prefixConfigCard.limitField.exceedError"
      defaultMessage="Character limit cannot exceed {maxLimit} characters."
      values={{ maxLimit }}
    />
  ),
  'prefixConfigCard.validationMessage.prefixTaken': (
    <FormattedMessage
      id="prefixConfigCard.validationMessage.prefixTaken"
      defaultMessage="Prefix in use."
    />
  ),
  'prefixConfigCard.validationMessage.prefixBlank': (
    <FormattedMessage
      id="prefixConfigCard.validationMessage.prefixBlank"
      defaultMessage="Prefix cannot be blank."
    />
  ),
  'prefixConfigCard.herdIdent.title': (
    <FormattedMessage
      id="prefixConfigCard.herdIdent.title"
      defaultMessage="Herd identity"
    />
  ),
  'prefixConfigCard.herdIdent.description': (
    <FormattedMessage
      id="prefixConfigCard.herdIdent.description"
      defaultMessage="Use the Tattoo Prefix."
    />
  ),
  'prefixConfigCard.herdIdent.fieldLabel': (
    <FormattedMessage
      id="prefixConfigCard.herdIdent.fieldLabel"
      defaultMessage="Prefix name label"
    />
  ),
  'prefixConfigCard.herdIdent.fieldPlaceholder': (
    <FormattedMessage
      id="prefixConfigCard.herdIdent.fieldPlaceholder"
      defaultMessage="Enter prefix name"
    />
  ),
  'prefixConfigCard.studName.title': (
    <FormattedMessage
      id="prefixConfigCard.studName.title"
      defaultMessage="Stud name"
    />
  ),
  'prefixConfigCard.studName.description': (
    <FormattedMessage
      id="prefixConfigCard.studName.description"
      defaultMessage="Displayed as animal owner."
    />
  ),
  'prefixConfigCard.studName.fieldLabel': (
    <FormattedMessage
      id="prefixConfigCard.studName.fieldLabel"
      defaultMessage="Prefix name label"
    />
  ),
  'prefixConfigCard.studName.fieldPlaceholder': (
    <FormattedMessage
      id="prefixConfigCard.studName.fieldPlaceholder"
      defaultMessage="Enter prefix name"
    />
  ),
  'prefixConfigCard.herdPrefix.title': (
    <FormattedMessage
      id="prefixConfigCard.herdPrefix.title"
      defaultMessage="Herd prefix"
    />
  ),
  'prefixConfigCard.herdPrefix.description': (
    <FormattedMessage
      id="prefixConfigCard.herdPrefix.description"
      defaultMessage="Use as animal name prefix."
    />
  ),
  'prefixConfigCard.herdPrefix.fieldLabel': (
    <FormattedMessage
      id="prefixConfigCard.herdPrefix.fieldLabel"
      defaultMessage="Prefix name label"
    />
  ),
  'prefixConfigCard.herdPrefix.fieldPlaceholder': (
    <FormattedMessage
      id="prefixConfigCard.herdPrefix.fieldPlaceholder"
      defaultMessage="Enter prefix name"
    />
  ),
};
